import { FC, useEffect, useState } from 'react'
import PopupApi from '../../../../infrastructure/api/PopupApi'
import { IPopupModel } from '../../../../models/responses/PopupModel'
import { PagedResponseModel } from '../../../../models/responses/PagedResponseModel'
import { IPaginationFilter } from '../../../../models/requests/PaginationFilter'
import { GenericTable } from '../../../components/tables/GenericTable'
import { TableHelperButtons } from '../../../components/buttons/TableHelperButtons'
import { TableHelperButtonEnum } from '../../../enums/TableHelperButtonEnum'
import { PopupWhoseEnum } from '../../../../enums/PopupWhoseEnum'
import { PopupWhereEnum } from '../../../../enums/PopupWhereEnum'
import { PopupWhenTypeEnum } from '../../../../enums/PopupWhenTypeEnum'

type Props = {
  onClickItem: (itemId: any, itemName: string, type: string) => void
  refresh: number
}

const PopupListModal: FC<Props> = ({ onClickItem, refresh }) => {
  const [popups, setPopups] = useState<PagedResponseModel<IPopupModel[]>>()
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchText, setSearchText] = useState('')
  const [sort, setSort] = useState('endDate_desc')

  useEffect(() => {
    const paginationFilter: IPaginationFilter = {
      page: pageNumber,
      size: pageSize,
      orderBy: sort,
      search: searchText,
    }
    async function getPopups() {
      var response = await PopupApi.GetPopups(paginationFilter)
      setPopups(response.data)
    }
    getPopups()
  }, [refresh, pageNumber, pageSize, searchText, sort])

  return (
    <>
      <GenericTable
        title='Popups'
        data={popups?.items}
        currentTotalRecords={popups?.totalRecords!!}
        currentPageNumber={popups?.pageNumber!!}
        columns={[
          {
            label: '#',
            name: '#',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return <>{(pageNumber - 1) * pageSize + ++dataIndex}</>
              },
              sort: false,
              viewColumns: false
            },
          },
          {
            label: 'Popup',
            name: 'image',
            options: {
              customBodyRender: (value) => {
                return (
                  <img
                    src={`${process.env.REACT_APP_CDN_URL}images/popup/${value}`}
                    width={80}
                  />
                )
              },
              sort: false
            },
          },
          {
            label: 'Title',
            name: 'title',
            options: {
              customBodyRender: (value) => {
                return <b>{value}</b>
              },
            },
          },
          { label: 'Message', name: 'message' },
          {
            label: 'Which Page',
            name: 'popupWhere',
            options: {
              customBodyRender: (value) => {
                return <div className='d-flex align-items-center'>{PopupWhereEnum[value]}</div>
              },
            },
          },
          {
            label: 'Who to',
            name: 'popupWhose',
            options: {
              customBodyRender: (value) => {
                return <div className='d-flex align-items-center'>{PopupWhoseEnum[value]}</div>
              },
            },
          },
          {
            label: 'Again',
            name: 'popupWhenType',
            options: {
              customBodyRender: (value) => {
                return <div className='d-flex align-items-center'>{PopupWhenTypeEnum[value]}</div>
              },
            },
          },
          {
            label: 'Date',
            name: 'startDate',
            options: {
              customBodyRenderLite: (dataIndex) => {
                return (
                  <div className='d-flex align-items-center'>
                    {popups?.items[dataIndex].startDate + ' / ' + popups?.items[dataIndex].endDate}
                  </div>
                )
              },
            },
          },
          {
            label: '#',
            name: 'Id',
            options: {
              customHeadLabelRender: (options) => {
                return (
                  <div className='d-flex justify-content-end flex-shrink-0'>{options.label}</div>
                )
              },
              customBodyRenderLite: (dataIndex) => {
                return (
                  <TableHelperButtons
                    itemId={popups?.items[dataIndex]?.id!!}
                    itemParam={popups?.items[dataIndex]?.title!!}
                    types={[TableHelperButtonEnum.Update, TableHelperButtonEnum.Delete]}
                    onClickItem={onClickItem}
                  />
                )
              },
              filter: false,
              sort: false,
              viewColumns: false,
            },
          },
        ]}
        customOptions={{
          rowsPerPage: pageSize,
          customTableBodyFooterRender: (opts) => {
            return <div></div>
          },
        }}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        setSearchText={setSearchText}
        setSort={setSort}
      />
    </>
  )
}

export { PopupListModal }
